import React from 'react';
import { Info } from '@material-ui/icons';
import Tooltip from '@material-ui/core/Tooltip';
import { useTranslation } from 'react-i18next';

const ExcludedIngredientsTooltip = () => {
  const { t } = useTranslation();
  return (
    <Tooltip
      title={
        <>
          <p>{t('form.dietExcludedInfo1')}</p>
          <p>{t('form.dietExcludedInfo2')}</p>
          <p>{t('form.dietExcludedInfo3')}</p>
          {t('form.dietExcludedInfo4')}
        </>
      }
      placement="right"
    >
      <Info fontSize="small" />
    </Tooltip>
  );
};

export default ExcludedIngredientsTooltip;
